module.exports = __webpack_public_path__ + "img/color-20x.4392eab7.svg";